import { SAASegmentFieldActions, ISAASegmentFieldsStore } from "../types/stores/saaSegmentFields";

export const SET_SAA_SEGMENTFIELD_LIST = "SET_SAA_SEGMENTFIELD_LIST";
export const SET_LOADING_SAA_SEGMENTFIELDS = "SET_LOADING_SAA_SEGMENTFIELDS";
export const SET_SAVING_SAA_SEGMENTFIELD = "SET_SAVING_SAA_SEGMENTFIELD";
export const SET_SELECTED_SAA_SEGMENTFIELD = "SET_SELECTED_SAA_SEGMENTFIELD";

const initialState: ISAASegmentFieldsStore = {
    saaSegmentFieldList: [],
    isLoadingList: false,
    isSaving: false,
    selectedId: 0,
};

function saaSegmentFields(state = initialState, action: SAASegmentFieldActions): ISAASegmentFieldsStore {
    switch (action.type) {
        case SET_SAA_SEGMENTFIELD_LIST:
            return Object.assign({}, state, {
                saaSegmentFieldList: action.saaSegmentFieldList,
            });
        case SET_LOADING_SAA_SEGMENTFIELDS:
            return Object.assign({}, state, {
                isLoadingList: action.isLoadingList,
            });
        case SET_SAVING_SAA_SEGMENTFIELD:
            return Object.assign({}, state, {
                isSaving: action.isSaving,
            });
        case SET_SELECTED_SAA_SEGMENTFIELD:
            return Object.assign({}, state, {
                selectedId: action.selectedId,
            });
        default:
            return state;
    }
}

export default saaSegmentFields;
